var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:`badge badge-`+_vm.opt.style+(_vm._events.click?' pointer':''),on:{"click":_vm.doClick}},[_vm._v(_vm._s(_vm.opt.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }